import MainMenuConfig from "@/core/config/MainMenuConfig";
import store from "@/store";

/**
 * Menü girdileri `showUserGroup: ['DEVELOPER']` ile sınırlandırılabilir.
 * Anahtar tanımlı değilse girdi herkese açıktır.
 *
 * Oturum bilgisi (`session.group.code`) her API yanıtıyla geldiği için
 * filtre, kullanıcı yüklendiği anda kendiliğinden güncellenir.
 */
export function isVisibleForGroup(item, groupCode) {
    if (!item.showUserGroup) {
        return true;
    }

    return !!groupCode && item.showUserGroup.includes(groupCode);
}

/**
 * Menü ağacını (pages/sub) kullanıcının grubuna göre süzer.
 * Alt girdileri tamamen elenen bölümler de listeden düşer.
 */
function filterItems(items, groupCode) {
    return (items ?? [])
        .filter((item) => isVisibleForGroup(item, groupCode))
        .map((item) => {
            if (!item.pages && !item.sub) {
                return item;
            }

            const next = Object.assign({}, item);

            if (item.pages) {
                next.pages = filterItems(item.pages, groupCode);
            }

            if (item.sub) {
                next.sub = filterItems(item.sub, groupCode);
            }

            return next;
        })
        .filter((item) => {
            // alt girdisi kalmayan bölüm başlıkları gösterilmez
            if (item.pages) {
                return item.pages.length > 0;
            }

            if (item.sub) {
                return item.sub.length > 0;
            }

            return true;
        });
}

/**
 * Oturumdaki kullanıcının grup kodu (henüz yüklenmediyse null).
 */
export function currentGroupCode() {
    return store.getters.currentUser?.group?.code ?? null;
}

/**
 * Kullanıcının görebileceği menü yapısı.
 */
export function getMenuConfig(groupCode = currentGroupCode()) {
    return filterItems(MainMenuConfig, groupCode);
}

/**
 * Bir rotanın hangi gruplara açık olduğunu menü tanımından bulur.
 * Rota menüde yoksa (ör. detay sayfaları) en yakın üst girdi baz alınır.
 */
export function getRouteGroups(path, items = MainMenuConfig, inherited = null) {
    let matched = null;

    for (const item of items) {
        // alt girdiler üstteki kısıtı devralır, kendi anahtarıyla ezebilir
        const groups = item.showUserGroup ?? inherited;
        const route = item.route ? item.route.replace(/\/+$/, '') : null;

        if (route && (path === route || path.startsWith(route + '/'))) {
            matched = groups ?? matched;
        }

        const children = item.pages ?? item.sub;

        if (children) {
            // daha derindeki (daha özel) eşleşme kazanır
            const found = getRouteGroups(path, children, groups);

            if (found) {
                matched = found;
            }
        }
    }

    return matched;
}

export default getMenuConfig;
